var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Form, Grid, Header, Select } from "semantic-ui-react";
import ErrorDisplay from "../../ErrorDisplay";
import { Channel, Plexity } from "../../KitDeserializer";
import { postJsonWithAuthn } from "../../RequestHelpers";
import { defaultChromogenState, populateChromogenStateWithPresetScales, populateDetectStateWithPresetScales } from "../automated-pro/AdminEditKitForm";
import { AmplifierForm } from "../automated-pro/AmplifierForm";
import ChromogenForm from "../automated-pro/ChromogenForm";
import { ProtocolTypeEnum } from "../automated-pro/EditKitForm";
import { EnzymeEnum, LiquidVolume, } from "../automated-pro/RnaCatalog";
import { buildOnComponentStateChangeHandler } from "../FormState";
import { defaultProbeSetState, defaultSampleTypeState, discountMessage, priceColumn, PriceDisplay, ToggleableKitComponent } from "../rna-fish/EditKitForm";
import { ErrorElementsWithPrices } from "../rna-fish/NewRnaFishKitPage";
import ProbeSetForm from "../rna-fish/ProbeSetForm";
import SelectSampleTypeForm from "../rna-fish/SelectSampleTypeForm";
import BufferForm from "./BufferForm";
import ManualProAdminKitSerializer from "./ManualProAdminKitSerializer";
import { findChromogenPresetScale, findDetectPresetScale } from "./ManualProConsumerDetectForm";
import { defaultBufferState } from "./ManualProConsumerKitForm";
var ManualProAdminKitForm = /** @class */ (function (_super) {
    __extends(ManualProAdminKitForm, _super);
    function ManualProAdminKitForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onPscStateChange = buildOnComponentStateChangeHandler(pscStateWrangler, _this.props.setFormState);
        _this.onDetectStateChange = buildOnComponentStateChangeHandler(detectStateWrangler, _this.props.setFormState);
        _this.onBuffersStateChange = buildOnComponentStateChangeHandler(buffersStateWrangler, _this.props.setFormState);
        _this.onSampleTypeStateChangeBaseHandler = buildOnComponentStateChangeHandler(sampleTypeStateWrangler, _this.props.setFormState);
        _this.onProbeSetEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { probeSetEnabled: !s.probeSetEnabled };
            }, function (newState) {
                if (newState.probeSetEnabled) {
                    _this.onProbeSetStateChange({}, _this.props.formState.probeSetState.hcrAmplifier, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onDetectComponentStateChange = function (updateObjOrFn, callback) {
            var stateCalculator;
            if (typeof updateObjOrFn === "function") {
                stateCalculator = function (oldState) {
                    // apply the provided function
                    return updateObjOrFn(oldState.detectState);
                };
            }
            else {
                stateCalculator = function () {
                    // just return the plain object
                    return updateObjOrFn;
                };
            }
            _this.props.setFormState(function (oldState) { return ({
                detectState: Object.assign({}, oldState.detectState, stateCalculator(oldState))
            }); }, function (newState) {
                _this.onPscStateChange({
                    hcrAmplifier: newState.detectState.channels[0].hcrAmplifier
                }, function () {
                    var ch1Enzyme = newState.detectState.channels[0].enzyme;
                    if (ch1Enzyme.id === "AP" || ch1Enzyme.id === "HRP") {
                        _this.onChromogenStateChange({
                            chromogen: {
                                id: 'NONE',
                                label: 'NONE',
                                platformCompatibility: [],
                                enzymeCompatibility: '',
                                bufferCompatibility: {
                                    id: 'NONE',
                                    label: 'NONE'
                                }
                            },
                            chromogenBuffer: {
                                id: 'NONE',
                                label: 'NONE'
                            },
                            chromogenScaleUl: 0,
                            chromogenBufferScaleUl: 0,
                            hematoxylinScaleUl: 0
                        }, callback);
                    }
                    else {
                        if (callback) {
                            callback(newState);
                        }
                    }
                });
            });
        };
        _this.onChromogenStateChange = function (updateObjOrFn, callback) {
            _this.props.setFormState(function (oldState) {
                var setState;
                if (typeof updateObjOrFn === "function") {
                    setState = updateObjOrFn(oldState.chromogenState);
                }
                else {
                    setState = updateObjOrFn;
                }
                var chromogenPresetScale = _this.chromogenPresetScale(undefined, setState.chromogen);
                var newChromogenState = Object.assign({}, oldState.chromogenState, setState);
                if (chromogenPresetScale) {
                    newChromogenState = populateChromogenStateWithPresetScales(newChromogenState, chromogenPresetScale);
                }
                return __assign(__assign({}, oldState), { chromogenPresetScale: chromogenPresetScale, chromogenState: newChromogenState });
            }, function (newState) {
                if (callback) {
                    callback(newState);
                }
            });
        };
        _this.onSampleTypeStateChange = function (sampleTypeFormState, prevSampleType, callback) {
            return _this.onSampleTypeStateChangeBaseHandler(sampleTypeFormState, function (newState) {
                var sampleType = newState.sampleTypeFormState.sampleType;
                // The detect (and chromogen) preset scale is Pro Flow-specific, so re-select it against the
                // new sample type whenever the sample type changes.
                var changeDetectPresetScale = function () {
                    _this.props.setFormState(function (oldState) {
                        var presetDetectScale = _this.detectPresetScale(oldState.detectScale, sampleType);
                        var presetChromogenScale = _this.chromogenPresetScale(oldState.detectScale, undefined);
                        return {
                            detectPresetScale: presetDetectScale,
                            detectState: presetDetectScale ? populateDetectStateWithPresetScales(oldState.detectState, presetDetectScale) : oldState.detectState,
                            chromogenPresetScale: presetChromogenScale,
                            chromogenState: presetChromogenScale ? populateChromogenStateWithPresetScales(oldState.chromogenState, presetChromogenScale) : oldState.chromogenState
                        };
                    }, callback);
                };
                if (sampleType.id === "NORTHERN_BLOT") {
                    _this.onBuffersStateChange({
                        probeWash: new LiquidVolume(0)
                    }, changeDetectPresetScale);
                }
                else if (prevSampleType.id === "NORTHERN_BLOT" && sampleType.id !== prevSampleType.id) {
                    _this.onBuffersStateChange({
                        probeWash: _this.props.catalog.goldFishBuffer.goldWash.defaultVolumeMl
                    }, changeDetectPresetScale);
                }
                else {
                    changeDetectPresetScale();
                }
            });
        };
        _this.onCommentChange = function (event) {
            var str = event.currentTarget.value;
            _this.props.setFormState(function () {
                return {
                    comment: str
                };
            });
        };
        _this.onProbeSetStateChange = function (updateObjOrFn, prevAmplifier, callback) {
            var stateCalculator;
            if (typeof updateObjOrFn === "function") {
                stateCalculator = function (oldState) {
                    // apply the provided function
                    return updateObjOrFn(oldState.probeSetState);
                };
            }
            else {
                stateCalculator = function () {
                    // just return the plain object
                    return updateObjOrFn;
                };
            }
            _this.props.setFormState(function (oldState) { return ({
                probeSetState: Object.assign({}, oldState.probeSetState, stateCalculator(oldState))
            }); }, function (newState) {
                // propagate to detect component
                var config = _this.props.catalog.proAmplifier.userConfigs.manualProAmps
                    .proAmpConfigList.find(function (a) {
                    return a.amplifier.id === newState.probeSetState.hcrAmplifier.id;
                });
                if (config == null) {
                    throw Error('Invalid channel');
                }
                _this.onDetectStateChange(function (old) { return ({
                    channels: old.channels.map(function (ch, i) { return i === 0 ? __assign(__assign({}, ch), { hcrAmplifier: config.amplifier, config: config }) : ch; })
                }); }, callback);
            });
        };
        _this.onDetectEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { detectEnabled: !s.detectEnabled };
            }, function (newState) {
                if (newState.detectEnabled) {
                    _this.onDetectStateChange({}, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onChromogenEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { chromogenEnabled: !s.chromogenEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onBuffersEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { buffersEnabled: !s.buffersEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onDetectScaleChange = function (_, data) {
            _this.props.setFormState(function (oldState) {
                var presetDetectScale = _this.detectPresetScale(data.value);
                var presetChromogenScale = _this.chromogenPresetScale(data.value, undefined);
                return {
                    detectPresetScale: presetDetectScale,
                    detectState: presetDetectScale ? populateDetectStateWithPresetScales(oldState.detectState, presetDetectScale) : oldState.detectState,
                    chromogenPresetScale: presetChromogenScale,
                    chromogenState: presetChromogenScale ? populateChromogenStateWithPresetScales(oldState.chromogenState, presetChromogenScale) : oldState.chromogenState,
                    detectScale: data.value
                };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.detectPresetScale = function (newScale, newSampleType) {
            var _a;
            var sampleType = newSampleType !== null && newSampleType !== void 0 ? newSampleType : _this.props.formState.sampleTypeFormState.sampleType;
            return findDetectPresetScale(_this.props.catalog.presetScales, ProtocolTypeEnum.MANUAL, (_a = newScale !== null && newScale !== void 0 ? newScale : _this.props.formState.detectScale) !== null && _a !== void 0 ? _a : _this.props.catalog.defaultAutomatedProScale, Plexity.OnePlex, sampleType.id === 'CELLS_SUSPENSION');
        };
        _this.chromogenPresetScale = function (newScale, newChromogen) {
            var _a, _b;
            var chromogenPresetScale;
            chromogenPresetScale = findChromogenPresetScale(_this.props.catalog.presetScales, ProtocolTypeEnum.MANUAL, (_a = newChromogen !== null && newChromogen !== void 0 ? newChromogen : _this.props.formState.chromogenState.chromogen) !== null && _a !== void 0 ? _a : undefined, (_b = newScale !== null && newScale !== void 0 ? newScale : _this.props.formState.detectScale) !== null && _b !== void 0 ? _b : _this.props.catalog.defaultManualProScale);
            return chromogenPresetScale;
        };
        _this.onUserSelection = function () {
            _this.loadPrice();
        };
        _this.loadPrice = function () {
            _this.props.setFormState(function () { return ({
                priceLoading: true
            }); }, function (newState) {
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(ManualProAdminKitForm.serializeManualProAdminKit(newState)))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) { return new ErrorElementsWithPrices(json.errors, json.price); });
                    }
                    return resp.json();
                }).then(function (resp) {
                    if (resp instanceof ErrorElementsWithPrices) {
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: resp.price
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        return _this;
    }
    ManualProAdminKitForm.prototype.render = function () {
        var _a;
        var protocolType = (_a = this.props.catalog.proPlatforms.find(function (c) { return c.id === 'MANUAL'; })) !== null && _a !== void 0 ? _a : (function () { throw new Error("Required Pro newPlatform not found"); })();
        return React.createElement("div", { className: 'kit-form' },
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: '/' }),
            React.createElement("div", null),
            React.createElement(Header, { className: "component-slider" },
                React.createElement("span", { className: 'sample-type-span' }, "Sample Type")),
            React.createElement("div", { className: 'no-outline-kit-component' },
                React.createElement(SelectSampleTypeForm, { sampleTypeState: this.props.formState.sampleTypeFormState, sampleTypes: this.props.catalog.manualProBuffer.sampleTypes, manualPro: true, onSampleTypeChange: this.onSampleTypeStateChange, onUserSelection: this.onUserSelection, showErrors: this.props.showErrors, errors: this.props.formState.errors })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.probeSetEnabled, otherComponentStates: [this.props.formState.detectEnabled, this.props.formState.chromogenEnabled, this.props.formState.buffersEnabled], onChange: this.onProbeSetEnableChange, label: "HCR™ HiFi Probe", cish: false },
                React.createElement(ProbeSetForm, { catalog: this.props.catalog, errors: this.props.formState.errors, enabled: this.props.formState.probeSetEnabled, enableNegativeControlProbe: this.props.enableNegativeControlProbe, enableCustomPrice: this.props.enableCustomPrice, enableCustomScale: true, onProbeSetChange: this.onProbeSetStateChange, onUserSelection: this.onUserSelection, effectivePriceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.probeSetPriceCents : undefined, listPriceCents: this.props.formState.price ? this.props.formState.price.listPrice.probeSetPriceCents : undefined, priceLoading: this.props.formState.priceLoading, probeSetState: this.props.formState.probeSetState, selectedSampleType: this.props.formState.sampleTypeFormState.sampleType, restrictCustomTargetProbeSetSizeToCatalog: false, manualPro: true, legacy: false, showErrors: this.props.showErrors })),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Header, null, "Detect scales"),
                    React.createElement(Select, { options: this.props.catalog.manualProScaleOptions.map(function (s) {
                            return {
                                text: s,
                                value: s
                            };
                        }), onChange: this.onDetectScaleChange, value: this.props.formState.detectScale, search: true }))),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.detectEnabled, label: 'AMPLIFIER', otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.chromogenEnabled, this.props.formState.buffersEnabled], onChange: this.onDetectEnableChange, cish: false },
                React.createElement(AmplifierForm, { plexity: Plexity.OnePlex, manualPro: true, detectState: this.props.formState.detectState, lockScales: true, protocolType: protocolType, channel: Channel.Channel1, catalog: this.props.catalog.proAmplifier, errors: this.props.formState.errors, onDetectStateChange: this.onDetectComponentStateChange, onChromogenStateChange: this.onChromogenStateChange, onUserSelection: this.onUserSelection, detectPresetScale: this.props.formState.detectPresetScale, priceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.detectPriceCents : undefined, priceLoading: this.props.formState.priceLoading, hcrAmplifierDisabled: this.props.formState.probeSetEnabled, enableCustomPrice: this.props.enableCustomPrice, detectComponent: undefined })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.chromogenEnabled, label: 'CHROMOGEN', otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.detectEnabled, this.props.formState.buffersEnabled], onChange: this.onChromogenEnableChange, cish: false },
                React.createElement(ChromogenForm, { protocolType: protocolType, detectEnabled: this.props.formState.detectEnabled, lockScales: true, ampState: this.props.formState.detectState, chromogenState: this.props.formState.chromogenState, nonOtherKit: true, allScales: 50, catalog: this.props.catalog.proChromogens, presetScales: this.props.formState.chromogenPresetScale, scaleOptions: this.props.catalog.manualProScaleOptions, errors: this.props.formState.errors, enableCustomPrice: this.props.enableCustomPrice, onChromogenChange: this.onChromogenStateChange, onUserSelection: this.onUserSelection, priceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.chromogenPriceCents : undefined, priceLoading: this.props.formState.priceLoading, chromogenComponent: undefined })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.buffersEnabled, otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.detectEnabled, this.props.formState.chromogenEnabled], onChange: this.onBuffersEnableChange, label: "HCR™ Buffers", cish: false },
                React.createElement(BufferForm, { sampleType: this.props.formState.sampleTypeFormState.sampleType, bufferState: this.props.formState.buffersState, catalog: this.props.catalog.goldFishBuffer, enableCustomPrice: this.props.enableCustomPrice, enableCustomScale: true, errors: this.props.formState.errors, onBufferChange: this.onBuffersStateChange, onUserSelection: this.onUserSelection, effectivePriceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.buffersPriceCents : undefined, listPriceCents: this.props.formState.price ? this.props.formState.price.listPrice.buffersPriceCents : undefined, priceLoading: this.props.formState.priceLoading, showErrors: this.props.showErrors })),
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: "/" }),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Form.Field, null,
                            React.createElement("label", { htmlFor: 'comment' }, "Comment"),
                            React.createElement(Form.TextArea, { value: this.props.formState.comment, onChange: this.onCommentChange }))),
                    priceColumn(React.createElement("div", { style: { 'paddingRight': '.5rem' } },
                        React.createElement(PriceDisplay, { loading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.subtotalCents : undefined })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 16 }, this.props.formState.price && discountMessage(this.props.formState.price.discountCents, this.props.formState.price.listPrice.subtotalCents)))));
    };
    ;
    ManualProAdminKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    ManualProAdminKitForm.serializeManualProAdminKit = function (formState) {
        var serializer = new ManualProAdminKitSerializer(formState.detectScale, formState.detectPresetScale, formState.chromogenPresetScale);
        if (formState.probeSetEnabled) {
            serializer.setProbeSetState(formState.probeSetState);
        }
        if (formState.detectEnabled) {
            serializer.setDetect(formState.detectState);
        }
        if (formState.buffersEnabled) {
            serializer.setBuffers(formState.buffersState);
        }
        if (formState.chromogenEnabled) {
            serializer.setChromogen(formState.chromogenState);
        }
        return serializer.serializeKit(formState.comment, formState.sampleTypeFormState.sampleType);
    };
    return ManualProAdminKitForm;
}(React.PureComponent));
export default ManualProAdminKitForm;
export var defaultManualProDetectState = function (catalog, presetScale) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var config = catalog.userConfigs.manualProAmps.proAmpConfigList.find(function (c) {
        return c.isDefault;
    });
    var ch1Channel = {
        config: config,
        hcrAmplifier: (_a = config === null || config === void 0 ? void 0 : config.amplifier) !== null && _a !== void 0 ? _a : catalog.defaultHcrAmplifier,
        hapten: (_b = config === null || config === void 0 ? void 0 : config.hapten) !== null && _b !== void 0 ? _b : catalog.defaultHapten,
        enzyme: (_c = config === null || config === void 0 ? void 0 : config.enzyme) !== null && _c !== void 0 ? _c : catalog.defaultEnzyme,
        editing: false,
        detectAntiHaptenUl: (_d = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectAntiHaptenUl) !== null && _d !== void 0 ? _d : 0,
        detectTyramideUl: (_e = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectTyramideUl) !== null && _e !== void 0 ? _e : 0,
        detectEnzymeApUl: ((_f = config === null || config === void 0 ? void 0 : config.enzyme) === null || _f === void 0 ? void 0 : _f.id) !== EnzymeEnum.HRP ? ((_g = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeApUl) !== null && _g !== void 0 ? _g : 0) : 0,
        detectEnzymeHrpUl: ((_h = config === null || config === void 0 ? void 0 : config.enzyme) === null || _h === void 0 ? void 0 : _h.id) !== EnzymeEnum.AP ? ((_j = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeHrpUl) !== null && _j !== void 0 ? _j : 0) : 0,
        detectHrpQuencherUl: (_k = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectHrpQuencherUl) !== null && _k !== void 0 ? _k : 0
    };
    return {
        channels: [ch1Channel],
        prefilled: false,
        pretreatADewaxUl: (_l = presetScale === null || presetScale === void 0 ? void 0 : presetScale.pretreatADewaxUl) !== null && _l !== void 0 ? _l : 0,
        pretreatBAntigenRetrievalUl: (_m = presetScale === null || presetScale === void 0 ? void 0 : presetScale.pretreatBAntigenRetrievalUl) !== null && _m !== void 0 ? _m : 0,
        pretreatBloxolUl: (_o = presetScale === null || presetScale === void 0 ? void 0 : presetScale.pretreatBloxolUl) !== null && _o !== void 0 ? _o : 0,
        detectAUl: (_p = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectAUl) !== null && _p !== void 0 ? _p : 0,
        detectBPmol: (_q = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectBPmol) !== null && _q !== void 0 ? _q : 0,
        detectBConcentration: (_r = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectBConcentration) !== null && _r !== void 0 ? _r : 0,
        detectBUl: (_s = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectBUl) !== null && _s !== void 0 ? _s : 0,
        detectCUl: (_t = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectCUl) !== null && _t !== void 0 ? _t : 0,
        postProcessAUl: (_u = presetScale === null || presetScale === void 0 ? void 0 : presetScale.postProcessAUl) !== null && _u !== void 0 ? _u : 0,
        postProcessBUl: (_v = presetScale === null || presetScale === void 0 ? void 0 : presetScale.postProcessBUl) !== null && _v !== void 0 ? _v : 0,
        preHybridizationUl: (_w = presetScale === null || presetScale === void 0 ? void 0 : presetScale.preHybridizationUl) !== null && _w !== void 0 ? _w : 0,
        scalesExpanded: false,
    };
};
export var defaultManualProDetectPresetScale = function (catalog) {
    return catalog.presetScales.presetProDetectScales.find(function (s) {
        return s.units === catalog.defaultManualProScale
            && s.platform.id === ProtocolTypeEnum.MANUAL;
    });
};
export var defaultManualProAdminFormState = function (catalog) {
    var ampCatalog = catalog.proAmplifier;
    var presetScale = defaultManualProDetectPresetScale(catalog);
    return {
        detectEnabled: true,
        buffersEnabled: true,
        chromogenEnabled: true,
        comment: '',
        errors: [],
        price: undefined,
        priceLoading: false,
        probeSetEnabled: true,
        detectPresetScale: presetScale,
        detectState: defaultManualProDetectState(ampCatalog, presetScale),
        buffersState: defaultBufferState(catalog),
        probeSetState: defaultProbeSetState(catalog, false, true),
        chromogenPresetScale: undefined,
        chromogenState: defaultChromogenState(),
        sampleTypeFormState: defaultSampleTypeState(),
        detectScale: catalog.defaultManualProScale
    };
};
var PscStateWrangler = /** @class */ (function () {
    function PscStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ probeSetState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.probeSetState; };
    }
    return PscStateWrangler;
}());
var DetectStateWrangler = /** @class */ (function () {
    function DetectStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ detectState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.detectState; };
    }
    return DetectStateWrangler;
}());
var BuffersStateWrangler = /** @class */ (function () {
    function BuffersStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ buffersState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.buffersState; };
    }
    return BuffersStateWrangler;
}());
var SampleTypeStateWrangler = /** @class */ (function () {
    function SampleTypeStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ sampleTypeFormState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.sampleTypeFormState; };
    }
    return SampleTypeStateWrangler;
}());
var pscStateWrangler = new PscStateWrangler();
var detectStateWrangler = new DetectStateWrangler();
var buffersStateWrangler = new BuffersStateWrangler();
var sampleTypeStateWrangler = new SampleTypeStateWrangler();
//# sourceMappingURL=ManualProAdminKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-pro/ManualProAdminKitForm.js
// module id = 131
// module chunks = 0